import { render, staticRenderFns } from "./WarnFilterPage.vue?vue&type=template&id=4c4639b2&"
import script from "./WarnFilterPage.vue?vue&type=script&lang=js&"
export * from "./WarnFilterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports